const ROUTE_VIEW_INDEX = [
  {
    path: '/index',
    name: '外壳',
    h5Uri: '/index/index',
    nativeUri: null,
    whiteList: true,
    children: [
      // 首页
      { path: '', name: '首页', component: resolve => require(['../../views/home/home.vue'], resolve), meta: { whiteList: true } },
      // 消息提醒
      { path: 'message', name: '消息提醒', component: resolve => require(['../../views/message/message.vue'], resolve) },
      // 就诊记录
      { path: 'record', name: '就诊记录', component: resolve => require(['../../views/record/record.vue'], resolve) },
      // 我的
      { path: 'user', name: '个人中心', component: resolve => require(['../../views/user/user.vue'], resolve), meta: { whiteList: true } }
    ]
  },
  { path: '/', redirect: '/index', whiteList: true },
  { path: '/index/message', name: '消息提醒', h5Uri: '/message/message', nativeUri: null, whiteList: false },
  { path: '/index/record', name: '就诊记录', h5Uri: '/record/record', nativeUri: null, whiteList: false },
  { path: '/index/user', name: '个人中心', h5Uri: '/user/user', nativeUri: null, whiteList: true }
]

export default ROUTE_VIEW_INDEX



// WEBPACK FOOTER //
// ./src/router/mapping/outSide.js